/* eslint-disable no-else-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-parens */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-destructuring */
/* eslint-disable indent */
/* eslint-disable function-paren-newline */

import './exam-desk-copy.scss';

const edcRequestForm = document.getElementById('hbg-edc-request-form');
if (edcRequestForm) {
  document.addEventListener('DOMContentLoaded', () => {
// Initialize Google Places Autocomplete with validation
const initializeAutocomplete = () => {
  const addressInput = document.getElementById('edc-request-address-1');
  
  if (!addressInput || !google?.maps?.places) return;

  const autocomplete = new google.maps.places.Autocomplete(addressInput, {
    types: ['address'],
    componentRestrictions: { country: ['us', 'ca'] }
  });

// Code to strip pasted ISBNS of spaces and dashes 
const cleanIsbnInput = (input) => {
  if (!input) return;
  
  // Strip spaces and dashes as user types
  input.addEventListener('input', function(e) {
    this.value = this.value.replace(/[\s-]/g, '');
  });
  
  // Handle paste events to clean immediately
  input.addEventListener('paste', function(e) {
    e.preventDefault();
    const pastedText = (e.clipboardData || window.clipboardData).getData('text');
    const cleanedText = pastedText.replace(/[\s-]/g, '');
    
    const start = this.selectionStart;
    const end = this.selectionEnd;
    const currentValue = this.value;
    this.value = currentValue.substring(0, start) + cleanedText + currentValue.substring(end);
    
    const newPosition = start + cleanedText.length;
    this.setSelectionRange(newPosition, newPosition);
    
    this.dispatchEvent(new Event('input', { bubbles: true }));
  });
};

// Strip spaces and dashes from the first ISBN input on page load
const firstIsbnInput = document.querySelector('.edc-title-lookup');
if (firstIsbnInput) {
  cleanIsbnInput(firstIsbnInput);
}

// Strip new ISBNs of spaces and dashes when new book sections are added. Also will work when users add a new course with new book sections.
const checkNewBooks = () => {
  const booksContainer = document.querySelector('.edc-book-section, .edc-courses-section');
  if (!booksContainer) return;
  
  const check = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.classList && node.classList.contains('edc-form-single-book-section')) {
          const newIsbnInput = node.querySelector('.edc-title-lookup');
          if (newIsbnInput) {
            cleanIsbnInput(newIsbnInput);
          }
        }
      });
    });
  });

  check.observe(booksContainer, { childList: true, subtree: true });
};

checkNewBooks();

  // Track if user selected from dropdown
  let addressSelected = false;
  let originalValue = '';

  // Mark when user selects from autocomplete dropdown
  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace();
    
    if (!place.geometry) {
      console.log(`No details available for input: '${place.name}'`);
      addressSelected = false;
      return;
    }

    addressSelected = true;

    // Clear existing values
    const fields = {
      'edc-request-address-1': '',
      'edc-request-address-2': '',
      'edc-request-address-city': '',
      'edc-request-address-state': '',
      'edc-request-address-zip': '',
      'edc-request-address-country': ''
    };
    
    Object.entries(fields).forEach(([id, value]) => {
      const field = document.getElementById(id);
      if (field) {
        field.value = value;
        field.classList.remove('edc-missing-field', 'address-not-validated');
      }
    });

    // Parse address components
    const addressData = place.address_components.reduce((acc, component) => {
      const type = component.types[0];
      const mapping = {
        'street_number': ['streetNumber', component.long_name],
        'route': ['route', component.long_name],
        'locality': ['city', component.long_name],
        'administrative_area_level_1': ['state', component.short_name],
        'postal_code': ['zipCode', component.long_name],
        'postal_code_suffix': ['zipSuffix', component.long_name],
        'country': ['country', component.short_name]
      };
      
      const [key, value] = mapping[type] ?? [];
      if (key) acc[key] = value;
      return acc;
    }, {});

    const {
      streetNumber = '',
      route = '',
      city = '',
      state = '',
      zipCode = '',
      zipSuffix = '',
      country = ''
    } = addressData;

    // Populate form fields
    const fullZip = zipSuffix ? `${zipCode}-${zipSuffix}` : zipCode;
    
    document.getElementById('edc-request-address-1').value = `${streetNumber} ${route}`.trim();
    document.getElementById('edc-request-address-city').value = city;
    document.getElementById('edc-request-address-state').value = state;
    document.getElementById('edc-request-address-zip').value = fullZip;
    document.getElementById('edc-request-address-country').value = country;

    // Mark address as validated
    addressInput.classList.add('address-validated');
    addressInput.classList.remove('address-not-validated');

    // Remove any existing warning messages
    const existingWarning = addressInput.parentElement.querySelector('.address-warning');
    if (existingWarning) {
      existingWarning.remove();
    }
  });

  // Track when user starts typing (reset validation)
  addressInput.addEventListener('input', () => {
    if (addressInput.value !== originalValue) {
      addressSelected = false;
      addressInput.classList.remove('address-validated');
    }
    originalValue = addressInput.value;
  });

  // Warn user if they didn't select from dropdown
  addressInput.addEventListener('blur', () => {
    if (addressInput.value.trim() !== '' && !addressSelected) {
      addressInput.classList.add('address-not-validated');
      
      // Add warning message if not already present
      if (!addressInput.parentElement.querySelector('.address-warning')) {
        const warning = document.createElement('p');
        warning.className = 'address-warning';
        warning.style.color = '#d9534f';
        warning.style.fontSize = '14px';
        warning.style.marginTop = '5px';
        warning.textContent = 'Please select an address from the dropdown suggestions to ensure accurate delivery.';
        addressInput.parentElement.appendChild(warning);
      }
    }
  });

  // Prevent form submission if address not validated
  const form = document.getElementById('hbg-edc-request-form');
  const submitButton = document.getElementById('edc-request-form-submit');
  
  if (submitButton) {
    const originalValidateForm = window.validateForm;
    
    window.validateForm = function() {
      // Run original validation first
      if (originalValidateForm && !originalValidateForm()) {
        return false;
      }

      // Check if address was entered but not validated
      const addressValue = addressInput.value.trim();
      if (addressValue !== '' && !addressSelected) {
        alert('Please select your address from the dropdown suggestions to ensure accurate delivery.');
        addressInput.classList.add('edc-missing-field');
        addressInput.focus();
        return false;
      }

      // Check if required address components are filled
      const city = document.getElementById('edc-request-address-city').value.trim();
      const state = document.getElementById('edc-request-address-state').value.trim();
      const zip = document.getElementById('edc-request-address-zip').value.trim();

      if (addressValue !== '' && (!city || !state || !zip)) {
        alert('Please select a complete address from the dropdown to auto-fill all address fields.');
        addressInput.classList.add('edc-missing-field');
        addressInput.focus();
        return false;
      }

      return true;
    };
  }
};

// Initialize with optional chaining
google?.maps?.places ? initializeAutocomplete() : window.addEventListener('load', initializeAutocomplete);
    // Remove books that are not the first book
    document.body.addEventListener('click', (event) => {
      if (event.target.closest('.edc-remove-book-btn')) {
        event.preventDefault();
        const bookSection = event.target.closest('.edc-form-single-book-section');
        if (bookSection) {
          bookSection.remove();
        }
      }
    });

    // Additional fields if quantity is greater than one
    document.body.addEventListener('change', (event) => {
        if (event.target.matches('select[name="quantity"]')) {
            const bookSection = event.target.closest('.edc-form-single-book-section');
            const quantity = parseInt(event.target.value, 10);
            const additionalFields = bookSection.querySelectorAll('.additional-fields-hide');
            additionalFields.forEach((field, index) => {
                if (index < quantity - 1) {
                    field.style.display = 'block';
                    field.classList.add('additional-copy-section');
                    const inputs = field.querySelectorAll('input, select, textarea');
                      inputs.forEach(input => {
                        input.classList.add('edc-required-field');
                      });
                } else {
                    field.style.display = 'none';
                    field.classList.remove('additional-copy-section');
                    const inputs = field.querySelectorAll('input, select, textarea');
                      inputs.forEach(input => {
                        input.classList.remove('edc-required-field'); // Remove class if not displayed
                    });
                }
            });
        }
    });

    // Remove courses that are not the first course
    document.body.addEventListener('click', (event) => {
      if (event.target.closest('.edc-remove-course-btn')) {
        event.preventDefault();
        const courseSection = event.target.closest('.edc-form-single-course-section');
        if (courseSection) {
          courseSection.remove();
        }
      }
    });

    // Counters to add unique ids to books and courses
    let bookCount = 1;
    let courseCount = 1;

    const addNewBook = (booksContainer) => {
      const currentBookCount = booksContainer.querySelectorAll('.edc-form-single-book-section').length;
      if (currentBookCount >= 5) {
        alert('You can only add up to 5 books per course.');
        return;
      }

      const firstBook = document.getElementById('edc-form-single-book-1');
      const newBook = firstBook.cloneNode(true);
      newBook.classList.add('edc-form-single-book-section');
      newBook.classList.remove('edc-hide');
      const reqFields = newBook.querySelectorAll('.edc-req-book-field');
      reqFields.forEach((element) => {
        element.classList.add('edc-required-field');
      });

      // Create a Unique ID for each new book
      bookCount += 1;
      newBook.id = `edc-form-single-book-${bookCount}`;

      // Find child element that needs a unique ID and update it
      const childElement = newBook.querySelector('.edc-title-lookup');
      if (childElement) {
        childElement.id = `search-form-${bookCount}`;
      }

      // Clear the input fields
      const inputs = newBook.querySelectorAll('input');
      inputs.forEach(input => input.value = '');

      // Handle quantity selection for new books
      const additionalFields = newBook.querySelectorAll('.additional-fields-hide');
      additionalFields.forEach(field => {
        field.style.display = 'none';
        field.classList.remove('additional-copy-section', 'edc-required-field');
      });

      // Find the "Add A Book" button
      const addBookBtn = booksContainer.querySelector('.edcAddBookBtn');

      // Insert the new book before the "Add A Book" button
      booksContainer.insertBefore(newBook, addBookBtn);
    };

    const addNewCourse = () => {
      const coursesContainer = document.querySelector('.edc-courses-section');
      const currentCourseCount = coursesContainer.querySelectorAll('.edc-form-single-course-section').length;
      if (currentCourseCount >= 5) {
        alert('You can only add up to 5 courses.');
        return;
      }

      const firstCourse = document.getElementById('edc-form-single-course-1');
      const newCourse = firstCourse.cloneNode(true);
      newCourse.classList.add('edc-form-single-course-section');

      // Create a Unique ID for each new course
      courseCount += 1;
      newCourse.id = `edc-form-single-course-${courseCount}`;

      // Clear the input fields and remove additional books.
      const inputs = newCourse.querySelectorAll('input');
      inputs.forEach(input => input.value = '');
      const extraBooks = newCourse.querySelectorAll('.edc-form-single-book-section');
      extraBooks.forEach((field, index) => {
        field.remove();
      });

      // Remove the hide class from the delete button if its not the first course
      const deleteBtn = newCourse.querySelector('.edc-remove-course-btn');
      if (deleteBtn.classList.contains('edc-hide')) {
        deleteBtn.classList.remove('edc-hide');
      }

      // Append new course section to the courses container
      coursesContainer.appendChild(newCourse);
    };

    // Attach event listeners to the buttons
    document.getElementById('edcAddCourseBtn').addEventListener('click', addNewCourse);

    // Use event delegation for the "Add Another Book" buttons
    document.querySelector('.edc-courses-section').addEventListener('click', (event) => {
      if (event.target && event.target.matches('.edcAddBookBtn')) {
        const courseSection = event.target.closest('.edc-form-single-course-section');
        if (courseSection) {
          const booksContainer = courseSection.querySelector('.edc-book-section');
          if (booksContainer) {
            addNewBook(booksContainer);
          }
        }
      }
    });
    // Attach event listener to the first course's "Add Another Book" button
    const firstCourseSection = document.getElementById('edc-form-single-course-1');
    const firstCourseBooksContainer = firstCourseSection.querySelector('.edc-book-section');
    const firstCourseAddBookBtn = firstCourseSection.querySelector('.edcAddBookBtn');

    if (firstCourseAddBookBtn) {
      firstCourseAddBookBtn.addEventListener('click', () => {
        addNewBook(firstCourseBooksContainer);
      });
    }
  });

  // Update country field by state selected
  document.addEventListener('DOMContentLoaded', () => {
    const state = document.getElementById('edc-request-address-state');
    const country = document.getElementById('edc-request-address-country');

    state.addEventListener('change', (event) => {
      const selectedOption = event.target.options[event.target.selectedIndex];

      if (selectedOption.classList.contains('edc-us-state')) {
        country.value = 'US';
      } else if (selectedOption.classList.contains('edc-ca-state')) {
        country.value = 'CA';
      } else {
        country.value = ''; // Clear or set default value if needed
      }
    });
  });

  // Function to handle form submission and API request
  const submitForm = async () => {
    // order id, 13 character timestamp
    const date = new Date();
    const timestamp = date.getTime();
    const orderId = `EDC${timestamp}`.substring(0, 13);
    // contact details
    const firstName = document.getElementById('edc-request-first-name').value;
    const lastName = document.getElementById('edc-request-last-name').value;
    const email = document.getElementById('edc-request-email').value;
    const phone = document.getElementById('edc-request-phone').value;
    const attnTo = document.getElementById('edc-request-attn').value;
    const institution = document.getElementById('edc-request-institution').value;
    const department = document.getElementById('edc-request-department').value;
    const position = document.getElementById('edc-request-position').value;
    const address1 = document.getElementById('edc-request-address-1').value;
    const address2 = document.getElementById('edc-request-address-2').value;
    const addressCity = document.getElementById('edc-request-address-city').value;
    const addressState = document.getElementById('edc-request-address-state').value;
    const zip = document.getElementById('edc-request-address-zip').value;
    const addressZip = zip.replace(/-$/, '');
    const addressCountry = document.getElementById('edc-request-address-country').value;

    // Collect course information
    const courses = [];

    const courseSections = document.querySelectorAll('.edc-courses-section > section');
    courseSections.forEach((courseSection, index) => {
      const course = {
        course_name: courseSection.querySelector('#edc-request-course-name').value,
        semester: courseSection.querySelector('#edc-request-course-semester').value,
        enrollment_num: courseSection.querySelector('#edc-request-course-enrollment').value,
        course_number: courseSection.querySelector('#edc-request-course-number').value,
        subject_area: courseSection.querySelector('#edc-request-course-subject').value,
        items: [],
      };

      const bookSections = courseSection.querySelectorAll('.edc-form-single-book-section');
      bookSections.forEach((bookSection) => {
        const rawAuthor = bookSection.querySelector('input[name="author"]').value;
        const formattedAuthor = rawAuthor.split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        const adtSections = [];
        const additionalCopySections = bookSection.querySelectorAll('.additional-copy-section');
        console.log(additionalCopySections);
        additionalCopySections.forEach((additionalCopySection) => {
          const additionalSection = {
            name: additionalCopySection.querySelector('.additional-field-name').value,
            position: additionalCopySection.querySelector('.additional-field-position').value,
            email: additionalCopySection.querySelector('.additional-field-email').value,
          };
          adtSections.push(additionalSection);
        });
        const book = {
          isbn: bookSection.querySelector('.edc-request-course-isbn').value,
          quantity: Number(bookSection.querySelector('select[name="quantity"]').value),
          title: bookSection.querySelector('input[name="title"]').value,
          author: formattedAuthor,
          bookstore_name: bookSection.querySelector('input[name="bookstore_name"]').value,
          contact: bookSection.querySelector('input[name="contact"]').value,
          copy_type: bookSection.querySelector('select[name="edc-copy-type"]').value,
          comments: bookSection.querySelector('input[name="comment"]').value,
          additional_copy_details: adtSections,
        };
        course.items.push(book);
      });

      courses.push(course);
    });

    // Create JSON object
    const data = {
      order_id: orderId,
      first_name: firstName,
      last_name: lastName,
      email,
      phone,
      institution,
      department,
      position,
      address: {
        street_address1: address1,
        street_address2: address2,
        city: addressCity,
        zip: addressZip,
        state: addressState,
        country: addressCountry,
      },
      newsletters_opt_in: false,
      insertUser: email,
      updateUser: email,
      attnTo,
      courses,
    };

    try {
      const jsonData = JSON.stringify(data);
      console.log(jsonData);
      const key = window.edc.key;
      const endpoint = window.edc.endpoint;

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Ocp-Apim-Subscription-Key': key,
        },
        body: jsonData,
      });

      if (!response.ok) {
        throw new Error('API request failed');
      }

      // Redirect to the confirmation page
      window.location.href = window.location.protocol+`//`+window.location.host+`/edc-confirmation?orderid=${encodeURIComponent(data.order_id)}`;
    } catch (error) {
      console.error('Error:', error);
    }
  };

  // Function to alert on blank fields
  const validateForm = () => {
    // email validation
    const email = document.getElementById('edc-request-email').value;
    if (email === '' || email.indexOf('@') === -1 || email.indexOf('.') === -1) {
      alert('Please enter a valid email address');
      document.getElementById('edc-request-email').classList.add('edc-missing-field');
      return false;
    } else {
      document.getElementById('edc-request-email').classList.remove('edc-missing-field');
    }

    // Bookstore contact email validation
    const bookstoreEmails = document.querySelectorAll('.edc-bookstore-email');
    for (let i = 0; i < bookstoreEmails.length; i += 1) {
      const emailField = bookstoreEmails[i];
      const contactEmail = emailField.value.trim();
      if (contactEmail !== '' && (contactEmail.indexOf('@') === -1 || contactEmail.indexOf('.') === -1)) {
        alert('Please enter a valid email address');
        emailField.classList.add('edc-missing-field');
        return false;
      } else {
        emailField.classList.remove('edc-missing-field');
      }
    }

    // Additional Field Email Validation
    const additionalFieldEmail = document.querySelectorAll('.additional-field-email');
    for (let i = 0; i < additionalFieldEmail.length; i += 1) {
      const emailField = additionalFieldEmail[i];
      const contactEmail = emailField.value.trim();
      if (contactEmail !== '' && (contactEmail.indexOf('@') === -1 || contactEmail.indexOf('.') === -1)) {
        alert('Please enter a valid email address');
        emailField.classList.add('edc-missing-field');
        return false;
      } else {
        emailField.classList.remove('edc-missing-field');
       }
    }

    // Un-Selected ISBN From List
    const isbnDataFields = document.querySelectorAll('.edc-title-lookup');
    if (isbnDataFields.length) {
      for (let i = 0; i < isbnDataFields.length; i++) {
        const field = isbnDataFields[i];
        const currentValue = field.value.trim();
        if (currentValue !== "") {
          const bookSection = field.closest('.edc-form-single-book-section');
          if (bookSection) {
            const isbnInput = bookSection.querySelector('.edc-request-course-isbn');
            if (isbnInput && isbnInput.value !== currentValue) {
              field.classList.add('error-isbn');

              // Add error message if not already present
              if (!field.nextElementSibling || !field.nextElementSibling.classList.contains('error-isbn-msg')) {
                const errorMsg = document.createElement('p');
                errorMsg.className = 'error-isbn-msg';
                errorMsg.textContent = 'Please re-enter and select the Title from the populated list.';
                field.insertAdjacentElement('afterend', errorMsg);
                return false;
              }
            } else {
              field.classList.remove('error-isbn');
              if (field.nextElementSibling && field.nextElementSibling.classList.contains('error-isbn-msg')) {
                field.nextElementSibling.remove();
              }
            }
          }
        }
      }
    }

    const requiredFields = document.querySelectorAll('.edc-required-field');
    let hasEmptyFields = false;

    for (let i = 0; i < requiredFields.length; i += 1) {
      const field = requiredFields[i];
      if ('value' in field && field.value.trim() === '') {
        requiredFields[i].classList.add('edc-missing-field');
        hasEmptyFields = true;
        console.log('there are empty fields');
      } else {
        requiredFields[i].classList.remove('edc-missing-field');
      }
    }

    if (hasEmptyFields) {
      alert('There is an empty or invalid entry. Please correct the error to proceed.');
      return false; // Prevent form submission
    }

    const singleBook = document.querySelectorAll('.edc-form-single-book-section');
    if (singleBook.length < 1) {
      alert('Please add a book to your request form.');
      return false;
    }

    // Form is valid
    return true;
  };

  // Grab form fields and send to the approval app on submit
  document.getElementById('edc-request-form-submit').addEventListener('click', (event) => {
    event.preventDefault();
    if (!validateForm()) {
      return;
    }

    submitForm();
  });
}